
export const topologyData = {
  "connectivity": [
    { "type": "EDI", "isActive": true },
    { "type": "eBill", "isActive": true },
    { "type": "eMail", "isActive": true },
    { "type": "Print", "isActive": false }
  ],
  "inbound": [
    { "type": "SFTP", "isActive": true, "path": "/settings/inbound/sftp" },
    { "type": "eMail", "isActive": true, "path": "/settings/inbound/email" },
    { "type": "API", "isActive": false, "path": "/settings/inbound/api" }
  ],
  "nodes": [
    { "label": "EDI CONNECTIVITY", "value": "12" },
    { "label": "EBILL NETWORK", "value": "3.036" },
    { "label": "DIGITAL EMAIL", "value": "579" },
    { "label": "PHYSICAL PRINT", "value": "252" }
  ],
  "ingestion": {
    "label": "Primary Ingestion",
    "value": 3879,
    "unit": "Files"
  }
};
